import React, { useEffect, useState, useContext } from "react"
import {
  getCategoryIconType,
  replaceUTF8Codes,
  removeImageDescription,
} from "../utilities"
import { getSubscriptionKeys } from "../../services/categorySubscriptions"
import { useSubscriptionPageUrl } from "../../hooks/headerLinks/subscriptionPage"
import DateFormat from "../date_format"
import DfbSymbol from "../ui-kit/dfb_symbol"
import DfbImage from "../ui-kit/dfb_image"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbIcon from "../ui-kit/dfb_icon"
import DfbParagraph from "../ui-kit/dfb_paragraph"
import DfbBreadcrumbs from "../ui-kit/dfb_breadcrumbs"
import CLightbox from "../elements/c_lightbox"
import CSubscribeIcon from "../elements/c_subscribe_icon"
import CIconButtonLink from "../elements/c_icon_button_link"
import { Transformation } from "cloudinary-react"
import PageContext from "../page-context"
import Section from "./section"
import moment from "moment"

const MOpener = (props) => {
  const { pageUid } = useContext(PageContext)
  const [subscriptionKeysData, setSubscriptionKeysData] = useState(null)
  const subscriptionPageUrl = useSubscriptionPageUrl()
  const hasCategories =
    props.data.root_categories && props.data.root_categories.length > 0

  let displayableCategories = []

  if (hasCategories) {
    displayableCategories =
      props.data.root_categories.filter((item) => {
        return item.description !== "" && item.description !== null
      }) || []
  }

  const initSubscriptionKeys = async () => {
    try {
      const keys = await getSubscriptionKeys()
      setSubscriptionKeysData({ keys })
    } catch (error) {
      setSubscriptionKeysData({ error })
    }
  }

  useEffect(() => {
    if (hasCategories) {
      initSubscriptionKeys()
    }
  }, [hasCategories])

  props.data.modal_id = `opener-modal`
  props.data.text = props.data.text.replace("<p>", "").replace("</p>", "")

  return (
    <Section baseClass="m-Opener" defaultPaddingTop="medium" data={props.data}>
      <div className="m-Opener-wrapper m-Opener-wrapper--content">
        <div className="m-Opener-container">
          <DfbBreadcrumbs {...props} />
          <div className="m-Opener-content">
            {props.data.kicker && (
              <p className="dfb-Paragraph dfb-Paragraph--small m-Opener-topline">
                {props.data.kicker}
              </p>
            )}
            {props.data.headline && (
              <DfbHeadline
                headline={props.data.headline}
                headline_level="h2"
                add_class="m-Opener-headline"
              />
            )}

            {props.data.text && (
              <p
                className="dfb-Paragraph m-Opener-excerpt"
                dangerouslySetInnerHTML={{ __html: props.data.text }}
              ></p>
            )}
            {props.pageData &&
              props.pageData.eventData &&
              ((props.pageData.eventData.location &&
                props.pageData.eventData.location.length > 0) ||
                (props.pageData.eventData.start &&
                  props.pageData.eventData.start.length > 0)) && (
                <div id="OPENER_META_EVENT" className="m-Opener-meta">
                  {props.pageData &&
                    props.pageData.eventData &&
                    props.pageData.eventData.location && (
                      <div className="c-Meta c-Meta--location m-Opener-metaItem">
                        <div className="c-Meta-graphic">
                          <DfbSymbol icon_type="Where" />
                        </div>
                        <div className="c-Meta-label">
                          {props.pageData.eventData.location}
                        </div>
                      </div>
                    )}
                  {props.pageData &&
                    props.pageData.eventData &&
                    props.pageData.eventData.start && (
                      <div className="c-Meta c-Meta--date m-Opener-metaItem">
                        <div className="c-Meta-graphic">
                          <DfbSymbol icon_type="When" />
                        </div>
                        <div className="c-Meta-label">
                          <DateFormat
                            startdate={props.pageData.eventData.start}
                            enddate={props.pageData.eventData.end}
                            format="DD.MM.YYYY, HH:mm [Uhr]"
                            forceTimeOutput={
                              ["appointment", "education"].indexOf(
                                props.pageData.type
                              ) !== -1
                                ? true
                                : false
                            }
                            withoutMarkup={true}
                          />
                        </div>
                      </div>
                    )}
                  {props.pageData &&
                    props.pageData.eventData &&
                    props.pageData.eventData.participants && (
                      <div className="c-Meta c-Meta--participants m-Opener-metaItem">
                        <div className="c-Meta-graphic">
                          <DfbSymbol icon_type="User Profile" />
                        </div>
                        <div className="c-Meta-label">
                          {props.pageData.eventData.participants}
                        </div>
                      </div>
                    )}
                  {props.pageData &&
                    props.pageData.eventData &&
                    props.pageData.eventData.start &&
                    moment(props.pageData.eventData.start).isAfter() &&
                    ["appointment", "education"].indexOf(
                      props.pageData.type
                    ) !== -1 && (
                      <a
                        id="WEBCAL_DOWNLOAD_LINK"
                        className="c-IconButtonLink m-Opener-icon-button-link"
                        href={`${process.env.REMOTE_EVENT_WEBCAL_API_ENDPOINT}?uid=${pageUid}`}
                        target="_blank"
                      >
                        <DfbIcon
                          icon_type="calendar"
                          add_class="c-IconButtonLink-icon"
                        />
                        <DfbParagraph
                          text="Termin herunterladen"
                          add_class="c-IconButtonLink-label"
                        />
                      </a>
                    )}
                </div>
              )}
            {hasCategories && displayableCategories.length > 0 && (
              <div id="OPENER_META_CATEGORY" className="m-Opener-meta">
                {hasCategories &&
                  displayableCategories.map((item) => (
                    <div
                      key={item.title}
                      className="c-Meta c-Meta--category m-Opener-metaItem"
                    >
                      <div className="c-Meta-graphic">
                        <DfbSymbol icon_type={getCategoryIconType(item)} />
                      </div>
                      <div className="c-Meta-label">{item.title}</div>
                      <CSubscribeIcon
                        title={item.title}
                        uid={item.uid}
                        add_class="c-Meta-subscribe-icon"
                        subscriptionKeysData={subscriptionKeysData}
                      />
                    </div>
                  ))}
                <CIconButtonLink
                  add_class="m-Opener-icon-button-link"
                  href={subscriptionPageUrl}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {props.data.image.src && (
        <div className="m-Opener-wrapper m-Opener-wrapper--image">
          <div className="m-Opener-container">
            <div
              className="m-Opener-image"
              data-toggle="modal"
              data-target={props.data.modal_id}
            >
              <DfbImage image={props.data.image} aspect_ratio="16:9">
                <Transformation
                  crop="fill"
                  gravity="faces:center"
                  width="905"
                  height="509"
                  quality="auto"
                  fetchFormat="auto"
                />
              </DfbImage>
              <CLightbox
                id={props.data.modal_id}
                image={removeImageDescription(props.data.image)}
                width="1600"
                height="900"
              ></CLightbox>
            </div>
          </div>
        </div>
      )}
    </Section>
  )
}

export default MOpener
